import { Button, DataSource, Label, Layout, Panel, } from "@mcleod/components";

export abstract class AutogenLayoutCarrierRateQuickInfo extends Layout {
    buttonCarrierRate: Button;
    labelCarrierRate: Label;
    labelRateId: Label;
    panel1: Panel;
    sourceCarrierRate: DataSource;
}
